import React from 'react';

import { Table } from '@yuhuinc/ui-library';
import capitalize from 'capitalize';

import { getTranslatedString } from 'helpers/i18n';
import moment from 'moment';

const mockDataSource = [
  {
    id: 1,
    key: 1,
    action: 'create',
    created_at: 'Aug 17, 2022 at 11:56am',
    remote_address: '142.112.199.35',
  },
  {
    id: 2,
    key: 2,
    action: 'update',
    created_at: 'Aug 17, 2022 at 11:56am',
    remote_address: '142.112.199.35',
    audited_changes: { some_updated_key_1: ['past', 'future'] },
  },
  {
    id: 3,
    key: 3,
    action: 'update',
    created_at: 'Aug 17, 2022 at 11:56am',
    remote_address: '142.112.199.35',
    audited_changes: { some_updated_key_2: ['old', 'new'] },
  },
];

const HistoryTable = ({ dataSource = mockDataSource, loading = false }) => {
  const columns = [
    {
      dataIndex: 'created_at',
      dataType: 'text',
      key: 'id',
      ellipsis: true,
      title: getTranslatedString(
        'landlordPortal.applicationManagement.applicationOverview.history.dateAndTime'
      ),
      width: '20%',
      render: (_, record) => moment(record.created_at).format('YYYY-MM-DD @ HH:mm'),
    },
    {
      dataIndex: 'action_name',
      dataType: 'text',
      key: 'action_name',
      ellipsis: true,
      title: getTranslatedString(
        'landlordPortal.applicationManagement.applicationOverview.history.action'
      ),
      width: '40%',
      render: (_, record) => capitalize(record.action_name),
    },
    {
      dataIndex: 'user_email',
      dataType: 'text',
      key: 'user_email',
      ellipsis: true,
      title: getTranslatedString(
        'landlordPortal.applicationManagement.applicationOverview.history.user'
      ),
      width: '25%',
    },
    {
      dataIndex: 'remote_address',
      dataType: 'text',
      key: 'remote_address',
      ellipsis: true,
      title: getTranslatedString(
        'landlordPortal.applicationManagement.applicationOverview.history.ipAddress'
      ),
      width: '15%',
    },
  ];

  return (
    <Table
      loading={loading}
      hideActionAndSearch={true}
      dataSource={dataSource}
      columns={columns}
      rowExpandable={(record) => record.action_name === 'update'}
      expandedRowRender={(record) => <ExpandedRow record={record} />}
    />
  );
};

export default HistoryTable;

const ExpandedRow = ({ record }) => {
  const columns = [
    {
      dataIndex: 'humanField',
      dataType: 'text',
      key: 'humanField',
      ellipsis: true,
      title: getTranslatedString('landlordPortal.incentives.field'),
      width: '25%',
    },
    {
      dataIndex: 'changed_from',
      dataType: 'text',
      key: 'changed_from',
      ellipsis: true,
      title: getTranslatedString('landlordPortal.incentives.changedFrom'),
      render(value, record) {
        if (value === null) {
          return '-';
        }

        if (value === true) {
          return 'True';
        }

        if (value === false) {
          return 'False';
        }

        return value;
      },
    },
    {
      dataIndex: 'changed_to',
      dataType: 'text',
      key: 'changed_to',
      ellipsis: true,
      title: getTranslatedString('landlordPortal.incentives.changedTo'),
      render(value, record) {
        if (value === null) {
          return '-';
        }

        if (value === true) {
          return 'True';
        }

        if (value === false) {
          return 'False';
        }

        return value;
      },
    },
  ];

  return (
    <Table
      hideActionAndSearch={true}
      columns={columns}
      size="small"
      pagination={false}
      dataSource={record.audited_changes}
    />
  );
};
